{
  "back": "Voltar",
  "badge": "Verificação oficial",
  "title": "Validação de certificado",
  "subtitle": "Informe o código (hash) do certificado para confirmar a autenticidade e visualizar o documento.",
  "search": {
    "placeholder": "Cole o código do certificado",
    "submit": "Validar"
  },
  "revoked": {
    "title": "Certificado revogado",
    "subtitle": "Este certificado foi revogado e não é mais válido."
  },
  "notFound": {
    "title": "Certificado não encontrado",
    "subtitle": "Verifique o código e tente novamente.",
    "requestFailed": "Não foi possível validar o código"
  },
  "footer": "Xtreed · Plataforma de ensino",
  "valid": {
    "title": "Certificado autêntico",
    "subtitle": "Emitido oficialmente pela plataforma.",
    "student": "Aluno",
    "content": "Conteúdo",
    "issuedAt": "Emitido em",
    "code": "Código"
  },
  "preview": {
    "fileName": "certificado-{{code}}.png",
    "iframeTitle": "Pré-visualização do certificado",
    "view": "Ver certificado",
    "download": "Baixar"
  }
}
